<!--
 * @FileDescription: [资质单位]ui规范
 * @Author: @liulin
 * @Date: 2023-01-04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-04 17:04:49
 -->
<template>
  <!-- 资质单位 -->
  <div ref="tablePanel" style="padding:20px">
    <div class="head-search" ref="headSearch">
      <div class="input">
        <el-input v-model="input" placeholder="请输入公司名/法人/资质类型">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <div class="container">
      <div class="operation-btn" ref="operationBtn">
        <el-button
          icon="el-icon-plus"
          type="primary"
          class="btn btn-plus"
          @click="handleAdd"
        >
          新增
        </el-button>
        <el-button icon="el-icon-delete" type="danger" class="btn btn-delete">
          删除
        </el-button>
      </div>
      <div class="container-table">
        <el-table
          :style="{ height: `${tableMaxHeight}` + 'px' }"
          :max-height="tableMaxHeight"
          :data="tableData"
          stripe
          style="width: 100%"
          header-cell-class-name="tableHeaderCellClassName"
          header-row-class-name="tableHeaderRowClassName"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="单位名称" width="250"></el-table-column>
          <el-table-column prop="person" label="法人" width="120"></el-table-column>
          <el-table-column prop="type" label="单位性质" width="100"></el-table-column>
          <el-table-column
            prop="code"
            label="统一社会信用代码"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="time"
            label="成立时间"
            width="120"
            sortable
          ></el-table-column>
          <el-table-column
            prop="address"
            label="单位办公地址"
            width="220"
          ></el-table-column>
          <el-table-column prop="number" label="手机号码" width="150"></el-table-column>
          <el-table-column prop="contact" label="联系人" width="120"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="{ row }">
              <el-link
                icon="el-icon-view"
                type="primary"
                :underline="false"
                class="cloumn-btn"
                @click="handleDetils"
              >
                详情
              </el-link>
              <el-link
                icon="el-icon-edit"
                type="primary"
                :underline="false"
                class="cloumn-btn"
                @click="handleEdit(row)"
              >
                编辑
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="container-pagination" ref="containerPagination">
        <el-pagination
          background
          layout="prev, pager, next, sizes, jumper"
          :total="1000"
        ></el-pagination>
      </div>
    </div>
    <Dialog ref="dialog" />
  </div>
</template>

<script>
import Dialog from './dialog.vue'
export default {
  components: {
    Dialog,
  },
  data() {
    return {
      input: '',
      tableMaxHeight: 400,
      tableData: [
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
        {
          name: '曜硕科技(上海)有限公司',
          person: '吴洁立',
          type: '私营企业',
          code: '230181991081407',
          time: '2022-09-06',
          address: '大红门服饰商贸城',
          number: '18335263645',
          contact: '孙子涵',
        },
      ],
    }
  },
  mounted() {
    this.calcTableHeight()
    this.$root.$on('resize', () => {
      this.calcTableHeight(500)
    })
    this.editElPaginationJumperText()
  },
  methods: {
    handleAdd() {
      this.$refs.dialog.open()
    },
    handleEdit(row) {
      this.$refs.dialog.edit(row)
    },
    handleDetils() {
      this.$router.push({ name: 'Detils' })
    },
    editElPaginationJumperText() {
      document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue =
        '跳至'
    },
    calcTableHeight(delay) {
      // 动态计算表格的高度，自适应当前容器,168是计算得出的margin和padding的距离
      setTimeout(() => {
        const tablePanelHeight = this.$refs.tablePanel.parentNode.clientHeight
        const headSearchHeight = this.$refs.headSearch.clientHeight
        const operationBtnHeight = this.$refs.operationBtn.clientHeight
        const containerPaginationHeight = this.$refs.containerPagination.clientHeight
        this.tableMaxHeight =
          tablePanelHeight -
          headSearchHeight -
          operationBtnHeight -
          containerPaginationHeight -
          156
      }, delay || 0)
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__row .cell {
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 19px;
  letter-spacing: 0px;
  color: #24262b;
}
/deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 2px #c4c4c4;
}
/deep/ .el-checkbox__inner::after {
  left: 6px;
  top: 2px;
}
/deep/ .el-pagination__jump {
  margin-left: 0;
}
.head-search {
  width: 100%;
  height: 78px;
  background-color: #ffffff;
  box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  overflow: hidden;
  .input {
    width: 340px;
    height: 40px;
    border-radius: 4px;
    margin: 19px 0;
    margin-left: 24px;
    /deep/ .el-input input,
    /deep/ .el-input-group__append {
      background-color: #f1f1f1;
      border: none;
    }
    /deep/ .el-input {
      input {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0px;
      }
      input::-webkit-input-placeholder {
        // 针对 谷歌 内核
        font-family: Microsoft YaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0px;
        color: #c4c4c4;
      }
      input:-moz-placeholder {
        // 火狐
        font-family: Microsoft YaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0px;
        color: #c4c4c4;
      }
      input:-ms-input-placeholder {
        // 微软ie
        font-family: Microsoft YaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0px;
        color: #c4c4c4;
      }
    }
  }
}
.container {
  width: 100%;
  // height: 858px;
  background-color: #ffffff;
  box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  margin-top: 16px;
  padding: 24px;
  box-sizing: border-box;
  .operation-btn {
    margin-bottom: 24px;
    .btn {
      height: 40px;
      width: 96px;
    }
    .btn-plus {
      background-color: #0147eb;
    }
    .btn-delete {
      background-color: #f04444;
    }
  }
  /deep/ .tableHeaderCellClassName .cell {
    font-family: Microsoft YaHei;
    font-size: 14px;
    // font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #545454;
  }

  /deep/ .tableHeaderRowClassName th {
    background-color: #ebecf0;
    padding: 5px 0;
  }
  .cloumn-btn {
    width: 76px;
    height: 32px;
  }
  .container-pagination {
    display: flex;
    justify-content: end;
    margin-top: 26px;
  }
}
</style>
